module.exports = __webpack_public_path__ + "img/设备设施.abdcba5c.svg";